import _slicedToArray from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js";
import "core-js/modules/es6.number.constructor.js";
import Vue from 'vue';
import { getScrollPosition, getScrollTarget, getHorizontalScrollPosition } from "../../utils/scroll.js";
import { listenOpts, noop } from "../../utils/event.js";
var passive = listenOpts.passive;
export default Vue.extend({
  name: 'QScrollObserver',
  props: {
    debounce: [String, Number],
    horizontal: Boolean,
    scrollTarget: {
      default: void 0
    }
  },
  render: noop,
  // eslint-disable-line
  data: function data() {
    return {
      pos: 0,
      dir: this.horizontal === true ? 'right' : 'down',
      dirChanged: false,
      dirChangePos: 0
    };
  },
  watch: {
    scrollTarget: function scrollTarget() {
      this.__unconfigureScrollTarget();
      this.__configureScrollTarget();
    },
    '$q.lang.rtl': function $qLangRtl() {
      this.__emit();
    }
  },
  methods: {
    getPosition: function getPosition() {
      return {
        position: this.pos,
        direction: this.dir,
        directionChanged: this.dirChanged,
        inflexionPosition: this.dirChangePos
      };
    },
    trigger: function trigger(immediately) {
      var _this = this;
      if (immediately === true || this.debounce === 0 || this.debounce === '0') {
        this.__emit();
      } else if (this.clearTimer === void 0) {
        var _ref = this.debounce ? [setTimeout(this.__emit, this.debounce), clearTimeout] : [requestAnimationFrame(this.__emit), cancelAnimationFrame],
          _ref2 = _slicedToArray(_ref, 2),
          timer = _ref2[0],
          fn = _ref2[1];
        this.clearTimer = function () {
          fn(timer);
          _this.clearTimer = void 0;
        };
      }
    },
    __emit: function __emit() {
      this.clearTimer !== void 0 && this.clearTimer();
      var fn = this.horizontal === true ? getHorizontalScrollPosition : getScrollPosition;
      var pos = Math.max(0, fn(this.__scrollTarget)),
        delta = pos - this.pos,
        dir = this.horizontal === true ? delta < 0 ? 'left' : 'right' : delta < 0 ? 'up' : 'down';
      this.dirChanged = this.dir !== dir;
      if (this.dirChanged) {
        this.dir = dir;
        this.dirChangePos = this.pos;
      }
      this.pos = pos;
      this.$emit('scroll', this.getPosition());
    },
    __configureScrollTarget: function __configureScrollTarget() {
      this.__scrollTarget = getScrollTarget(this.$el.parentNode, this.scrollTarget);
      this.__scrollTarget.addEventListener('scroll', this.trigger, passive);
      this.trigger(true);
    },
    __unconfigureScrollTarget: function __unconfigureScrollTarget() {
      if (this.__scrollTarget !== void 0) {
        this.__scrollTarget.removeEventListener('scroll', this.trigger, passive);
        this.__scrollTarget = void 0;
      }
    }
  },
  mounted: function mounted() {
    this.__configureScrollTarget();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearTimer !== void 0 && this.clearTimer();
    this.__unconfigureScrollTarget();
  }
});